<template>
	<div class="language-selector">
		<v-menu>
			<template v-slot:activator="{ props }">
				<v-btn variant="text" class="language-btn" v-bind="props">
					<v-icon :start="!mobile">mdi-translate</v-icon>
					<span v-if="!mobile" class="language-text">
						{{ getCurrentLanguageShort() }}
					</span>
				</v-btn>
			</template>
			<v-list>
				<v-list-item
					v-for="(lang, i) in languages"
					:key="i"
					@click="changeLanguage(lang.code)"
					:active="currentLanguage === lang.code"
				>
					<template v-slot:prepend v-if="currentLanguage === lang.code">
						<v-icon color="primary">mdi-check</v-icon>
					</template>
					<v-list-item-title>{{ lang.name }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useLocale } from "@/composables/useLocale";
import { useDisplay } from "vuetify";

// Composables
const { locale, availableLocales, changeLocale } = useLocale();
const { mobile } = useDisplay();

// Data
const languages = ref([
	{ code: "pt-BR", name: "Português", short: "PT" },
	{ code: "en-US", name: "English", short: "EN" },
	{ code: "es-ES", name: "Español", short: "ES" },
	{ code: "fr-FR", name: "Français", short: "FR" },
]);

// Computed
const currentLanguage = computed(() => {
	return locale.value;
});

// Methods
const getCurrentLanguageShort = () => {
	const lang = languages.value.find((lang) => lang.code === locale.value);
	return lang ? lang.short : "PT";
};

const changeLanguage = (langCode: string) => {
	changeLocale(langCode);
};
</script>

<style scoped>
.language-btn {
	min-width: auto;
	letter-spacing: normal;
}
</style>
